import type { OrderComponents } from "@opensea/seaport-js/lib/types";

const API_URL = import.meta.env.VITE_API_URL;

export type ListOrdersResponse = {
	orders: {
		orderHash: string;
		orderType: number;
		offerer: string;
		status: string;
		startTime: number;
		endTime: number;
		salt: string;
		conduitKey: string;
		totalOriginalConsiderationItems: number;
		counter: number;
		orderData: OrderComponents;
		signature: string;
	}[];
	totalOrders: number;
	limit: number;
	page: number;
};

export type GetOrdersParams = {
	page?: number;
	limit?: number;
	// biome-ignore lint/suspicious/noExplicitAny: <explanation>
	[key: string]: any;
};

// Infinite query fetcher with pagination and filters
const fetchOrders = async ({
	page = 1,
	limit = 8,
	...params
}: GetOrdersParams): Promise<ListOrdersResponse> => {
	const url = new URL(`${API_URL}/marketplace/orders`);
	url.searchParams.set("page", String(page));
	url.searchParams.set("limit", String(limit));
	for (const [key, value] of Object.entries(params)) {
		if (value !== undefined && value !== "")
			url.searchParams.set(key, String(value));
	}

	const res = await fetch(url.toString(), {
		headers: { "Content-Type": "application/json" },
	});

	if (!res.ok) {
		const error = await res.text();
		throw new Error(`Fetching orders failed: ${error}`);
	}

	const json = await res.json();
	return json.data;
};

// Returns options object for useInfiniteQuery
export const getOrdersOptions = (params: GetOrdersParams) => ({
	queryKey: ["marketplace", "orders", params],
	queryFn: () => fetchOrders({ ...params }),
});
